import { LassieMini, Lassie, ShuttleRack, Design, HikStorage } from '@thive/fddm-types';
import { Vector2 } from 'three';

import { ITpsService } from './ITpsService';
import { logger } from '@/modules/common/logging/logger';

export class TpsServiceExceptionDecorator implements ITpsService {
  private decoree: ITpsService;

  constructor(decoree: ITpsService) {
    this.decoree = decoree;
  }

  async generateLassieTemplate(center: Vector2): Promise<void> {
    try {
      await this.decoree.generateLassieTemplate(center);
    } catch (err) {
      this.logError('generateLassieTemplate', err);
    }
  }

  async generateLassieMiniTemplate(center: Vector2): Promise<void> {
    try {
      await this.decoree.generateLassieMiniTemplate(center);
    } catch (err) {
      this.logError('generateLassieMiniTemplate', err);
    }
  }

  async generateShuttleTemplate(center: Vector2): Promise<void> {
    try {
      await this.decoree.generateShuttleTemplate(center);
    } catch (err) {
      this.logError('generateShuttleTemplate', err);
    }
  }

  async generateHikTemplate(center: Vector2): Promise<void> {
    try {
      await this.decoree.generateHikTemplate(center);
    } catch (err) {
      this.logError('generateHikTemplate', err);
    }
  }

  async regenerateLassieTemplate(
    lassieGroup: Lassie,
  ): Promise<{ result: 'success'; data: Design } | { result: 'failed' }> {
    try {
      return await this.decoree.regenerateLassieTemplate(lassieGroup);
    } catch (err) {
      this.logError('regenerateLassieTemplate', err);
    }

    return { result: 'failed' };
  }

  async regenerateLassieMiniTemplate(
    lassieMiniGroup: LassieMini,
  ): Promise<{ result: 'success'; data: Design } | { result: 'failed' }> {
    try {
      return await this.decoree.regenerateLassieMiniTemplate(lassieMiniGroup);
    } catch (err) {
      this.logError('regenerateLassieMiniTemplate', err);
    }

    return { result: 'failed' };
  }

  async regenerateShuttleTemplate(
    shuttleGroup: ShuttleRack,
  ): Promise<{ result: 'success'; data: Design } | { result: 'failed' }> {
    try {
      return await this.decoree.regenerateShuttleTemplate(shuttleGroup);
    } catch (err) {
      this.logError('regenerateShuttleTemplate', err);
    }

    return { result: 'failed' };
  }

  async regenerateHikTemplate(
    hikGroup: HikStorage,
  ): Promise<{ result: 'success'; data: Design } | { result: 'failed' }> {
    try {
      return await this.decoree.regenerateHikTemplate(hikGroup);
    } catch (err) {
      this.logError('regenerateHikTemplate', err);
    }
    return { result: 'failed' };
  }

  // private utility methods

  private logError(methodName: string, error: unknown): void {
    logger.error(`TpsService.${methodName} failed:`, error);
  }
}
